module.exports = __webpack_public_path__ + "assets/img/17_1045.6f165254.jpg";